<top-banner variant="custom">
    <h2 class="title mb-3 animated fadeIn">
      Create New Site
    </h2>
</top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <h4 class="card-title">Details</h4>
            <div class="mb-2 animated fadeIn">
              <form [formGroup]="createSiteForm" (ngSubmit)="onCreateSiteFormSubmit()">
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Name</label>
                      <input type="text" class="form-control" formControlName="name" placeholder="Enter site name">
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Description</label>
                      <textarea type="text" class="form-control with-autoresize" appTextareaAutoresize formControlName="description" placeholder="Enter site description..."></textarea>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="card border p-3 mt-3">
                      <h5 class="card-title">Contact Numbers</h5>
                      <div class="form-row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Main Contact Number</label>
                            <input type="text" class="form-control" formControlName="mainContactNumber" placeholder="">
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Emergency Contact Number</label>
                            <input type="text" class="form-control" formControlName="emergencyContactNumber" placeholder="">
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Regional Emergency Contact Number</label>
                            <input type="text" class="form-control" formControlName="altEmergencyContactNumber" placeholder="">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6" *ngIf="siteOwners.length">
                    <div class="form-group">
                      <label>Owner</label>
                      <p-dropdown
                          class="form-control"
                          [(ngModel)]="selectedOwner"
                          (ngModelChange)="onSelectedSiteOwnerChange($event)"
                          [ngModelOptions]="{standalone: true}"
                          [options]="siteOwners"
                          optionLabel="label"
                          [style]="{'width':'100%'}"
                          filter="true"
                      ></p-dropdown>
                    </div>
                  </div>
                  <div class="col-md-6" *ngIf="siteTypes.length">
                    <div class="form-group">
                      <label>Site Type</label>
                      <p-dropdown
                          class="form-control"
                          [(ngModel)]="selectedSiteType"
                          (ngModelChange)="onSelectedSiteTypeChange($event)"
                          [ngModelOptions]="{standalone: true}"
                          [options]="siteTypes"
                          optionLabel="label"
                          [style]="{'width':'100%'}"
                          filter="true"
                      ></p-dropdown>
                    </div>
                  </div>
                  <div class="col-md-12" *ngIf="siteInductions.length">
                    <div class="form-group">
                      <label>Site Induction</label>
                      <p-dropdown
                          class="form-control"
                          (ngModelChange)="onSelectedSiteInductionChange($event)"
                          [ngModelOptions]="{standalone: true}"
                          [options]="siteInductions"
                          optionLabel="label"
                          [style]="{'width':'100%'}"
                          filter="true"
                      ></p-dropdown>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Waypoint Interval (minutes)</label>
                      <input type="number" class="form-control" formControlName="waypointInterval" placeholder="Time in minutes between waypoint">
                    </div>
                  </div>
                  <!-- not used anymore
                  <div class="col-md-12">
                    <div class="form-group form-group-checkbox">
                      <label>Assets can have Competencies?</label>
                      <p-checkbox class="form-control" formControlName="addAssetCompetencies" binary="true"></p-checkbox>
                    </div>
                  </div>
                  -->
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="location">Location</label><br>
                      <input class="form-control" id="location" style="width: 100%;" ngx-google-places-autocomplete #placesRef="ngx-places" (onAddressChange)="handleAddressChange($event)" />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" style="height: 500px;">
                      <agm-marker [latitude]="lat" [longitude]="lng" [markerDraggable]="true" (dragEnd)="markerDragEnd($event)"></agm-marker>
                    </agm-map>
                  </div>
                  <div class="col-md-12">
                    <button type="submit" class="btn btn-success btn-round">
                      Create
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
